// ─── «Inscritos»: UNA regla para todas las pantallas (puro, con test) ───────
// Antes cada pantalla contaba a su manera: el selector de sección y el detalle
// del período contaban solo `enrolled` (una sección de la historia se veía con
// 0), /sections sumaba el campo `currentEnrollment` (que el import llenó con
// el total histórico, retiros incluidos), y el detalle mostraba el cupo como
// si fuera real. Tres números distintos para la misma sección.
//
// LA REGLA: inscrito es toda inscripción que no sea un retiro (`dropped`).
//   · En un período en curso son los que están cursando (`enrolled`).
//   · En uno cerrado son los que cursaron (`approved`, `failed`).
// Es lo mismo que mantiene el servidor en `currentEnrollment`: suma al
// inscribir y resta solo al retirar. La misma regla, para corregir los datos
// importados, vive en apps/functions/scripts/import-labts/capacity.core.ts, que
// hoy la toma del dominio.
//
// CUPO: `maxEnrollment` 0 (o ausente) = sin cupo definido. Se muestran los
// inscritos sin «/cupo» y sin barra de ocupación. La regla es del DOMINIO
// (`sectionCapacity`, @dosfilos/domain): el servidor la usa para decidir si hay
// lugar, así que el web no puede tener otra.
import { sectionCapacity } from '@dosfilos/domain';

// La regla de «inscrito» vive en el dominio desde el PR 3A (el servidor también
// cuenta inscritos). Se reexporta para no mover a todos los que la importan.
export { COUNTED_ENROLLMENT_STATUSES, countsAsEnrolled } from '@dosfilos/domain';

/** Un cupo de verdad (mayor que 0). Sin él, no hay «/cupo» ni ocupación. */
export const definedCapacity = sectionCapacity;
